import { render, staticRenderFns } from "./event-records.vue?vue&type=template&id=6c4df608&scoped=true"
import script from "./event-records.vue?vue&type=script&lang=js"
export * from "./event-records.vue?vue&type=script&lang=js"
import style0 from "./event-records.vue?vue&type=style&index=0&id=6c4df608&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4df608",
  null
  
)

export default component.exports